import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { FormFactory } from '../../factories/FormFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Form extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new FormFactory
  }

  elementIds() {
    return [
      'buttonId', 'id'
    ]
  }

  elementClasses() {
    return ['buttonClasses', 'labelClasses', 'inputClasses', 'classes']
  }

  elementContents() {
    return ['method', 'action', 'hasHoneypot', 'showLabels', 'showPlaceholder', 'leadTags', 'sendMail', 'toMails', 'frontendValidation', 'leadList', 'hasRecaptcha', 'rows']
  }

  elementStyles() {
    return [
      {element: 'class', styles: 'inputStyles', selector: '.wf-form-input'},
      {element: 'class', styles: 'labelStyles', selector: '.wf-form-label'},
      {id: 'buttonId', element: 'id', styles: 'buttonStyles', selector: '#', variation: null},
      {element: 'class', styles: 'focusedInputStyles', selector: '.wf-form-input', suffix: ':focus'},
      {element: 'class', styles: 'errorInputStyles', selector: '.wf-form-input--error'},
    ]
  }

  info() {
    return {
      name: 'Form',
      icon: 'fa-pencil-alt',
      variations: this.variationsInfo()
    }
  }
}